import {UserRole} from '@/types/user-role';
import {v4 as uuidv4} from 'uuid';

export class UserClass {
  constructor(
    public id: string = uuidv4(),
    public name = '',
    public active = true,
    public email = '',
    public login = '',
    public password = '',
    public role = UserRole.USER,
  ) {
  }
}
